import { useMemo } from 'react';
import { useGetProfile } from './useProfile.ts';

export const useIsAdmin = () => {
  const { data: profile } = useGetProfile();
  
  const isAdmin = useMemo(() => {
    if (!profile?.data) return false;
    return profile.data.current_role === 'admin' && profile.data.is_group_admin === true;
  }, [profile]);

  return isAdmin;
}; 

export const useIsGroupAdmin = () => {
  const { data: profile } = useGetProfile();
  
  const isAdmin = useMemo(() => {
    if (!profile?.data) return false;
    return profile.data.is_group_admin === true;
  }, [profile]);

  return isAdmin;
}; 